import tools from './methods';
export default {
    formatUnit(value){
        return tools.formatUnit(value);
    }
}


// WEBPACK FOOTER //
// ./src/utils/filter.js